<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.4081 10.4273C27.0325 10.6305 25.5823 10.9035 24 11.2401C22.4177 10.9035 20.9676 10.6305 19.5919 10.4273C20.8369 10.9161 22.1024 11.5042 23.4369 12.1486C23.7815 12.315 24 12.6645 24 13.0471C24 12.6645 24.2185 12.315 24.5631 12.1486C25.8976 11.5041 27.1631 10.9161 28.4081 10.4273ZM24 35.4011C24 35.9788 23.5269 36.4002 23 36.4083V36.6048C16.7313 35.5437 12.3024 35.4774 6 36.5828V13.0333C6.69172 12.8756 7.3564 12.7368 8 12.6163V10.5834C6.97407 10.7669 5.89999 10.9953 4.75659 11.2707C4.31119 11.378 4 11.7783 4 12.2365V37.775C4 38.4077 4.58268 38.8804 5.20425 38.7619C12.2798 37.412 16.7293 37.4919 23.808 38.7772C23.8729 38.789 23.9374 38.7944 24.0007 38.7937C24.0636 38.7943 24.1276 38.7889 24.192 38.7772C31.2707 37.4919 35.7202 37.412 42.7957 38.7618C43.4173 38.8804 44 38.4077 44 37.7749V12.2365C44 11.7783 43.6888 11.378 43.2434 11.2707C42.1 10.9952 41.0259 10.7669 40 10.5834V12.6162C40.6436 12.7368 41.3083 12.8756 42 13.0333V36.5827C35.6976 35.4774 31.2687 35.5437 25 36.6047V36.4083C24.4731 36.4002 24 35.9788 24 35.4011Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 10.5065V33.0552C9 33.0555 9 33.055 9 33.0552C9.00104 33.0567 9.00329 33.0602 9.00746 33.0635C9.02183 33.075 9.04034 33.0801 9.06045 33.0764C14.4001 32.0966 18.4125 33.2958 22.9753 35.4054C22.9805 35.4078 22.9831 35.4083 22.9835 35.4083L22.985 35.4084C22.9868 35.4083 22.9915 35.4073 22.9968 35.4039C22.9982 35.4031 22.9992 35.4023 23 35.4016C23 35.4015 23 35.4018 23 35.4016L23 13.0481C18.0208 10.6436 14.2661 9.16738 9 10.5065ZM23 13.0481C23 13.048 23 13.048 23 13.0481V13.0481ZM8.47389 8.57671C14.4926 7.03563 18.8207 8.80875 23.8718 11.2481C24.5632 11.582 25 12.2822 25 13.0471V35.4011C25 36.8882 23.4525 37.8295 22.1359 37.2208C17.7555 35.1955 14.1869 34.1692 9.42139 35.0435C8.2104 35.2657 7 34.3654 7 33.0552V10.492C7 9.61248 7.58253 8.80494 8.47389 8.57671Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39 10.5065V33.0552C39 33.0555 39 33.055 39 33.0552C38.999 33.0567 38.9967 33.0602 38.9925 33.0635C38.9782 33.075 38.9597 33.0801 38.9396 33.0764C33.5999 32.0966 29.5875 33.2958 25.0247 35.4054C25.0195 35.4078 25.0169 35.4083 25.0165 35.4083L25.015 35.4084C25.0132 35.4083 25.0085 35.4073 25.0032 35.4039C25.0018 35.4031 25.0008 35.4018 25 35.4011C25 35.4009 25 35.4013 25 35.4011V13.0471C29.9792 10.6426 33.7339 9.16738 39 10.5065ZM25 13.0471C25 13.047 25 13.047 25 13.0471V13.0471ZM39.5261 8.57671C33.5074 7.03563 29.1793 8.80875 24.1282 11.2481C23.4368 11.582 23 12.2832 23 13.0481L23 35.4016C23 36.8887 24.5475 37.8295 25.8641 37.2208C30.2445 35.1955 33.8131 34.1692 38.5786 35.0435C39.7896 35.2657 41 34.3654 41 33.0552V10.492C41 9.61248 40.4175 8.80494 39.5261 8.57671Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0104 29.0026C14.6795 28.9646 16.7269 29.3354 20.622 30.9258L21.378 29.0742C17.2509 27.389 14.9401 26.9618 10.9896 27.0027L11.0104 29.0026Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0104 25.0026C14.6795 24.9646 16.7269 25.3354 20.622 26.9258L21.378 25.0742C17.2509 23.389 14.9401 22.9618 10.9896 23.0027L11.0104 25.0026Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0104 21.0026C14.6795 20.9646 16.7269 21.3354 20.622 22.9258L21.378 21.0742C17.2509 19.389 14.9401 18.9618 10.9896 19.0027L11.0104 21.0026Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5 13V16H11.5V13H13.5Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17 14V17H15V14H17Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5 15V18H18.5V15H20.5Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.9896 29.0026C33.3205 28.9646 31.2731 29.3354 27.378 30.9258L26.622 29.0742C30.7491 27.389 33.0599 26.9618 37.0103 27.0027L36.9896 29.0026Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.9896 25.0026C33.3205 24.9646 31.2731 25.3354 27.378 26.9258L26.622 25.0742C30.7491 23.389 33.0599 22.9618 37.0103 23.0027L36.9896 25.0026Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.9896 21.0026C33.3205 20.9646 31.2731 21.3354 27.378 22.9258L26.622 21.0742C30.7491 19.389 33.0599 18.9618 37.0103 19.0027L36.9896 21.0026Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.5 13V16H36.5V13H34.5Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31 14V17H33V14H31Z"
      fill="#333333"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.5 15V18H29.5V15H27.5Z"
      fill="#333333"
    />
  </svg>
</template>
